// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TriggerVtmfFilingRequest
 */
export interface TriggerVtmfFilingRequest {
    /**
     * 
     * @type {string}
     * @memberof TriggerVtmfFilingRequest
     */
    idempotency_key?: string;
}

/**
 * Check if a given object implements the TriggerVtmfFilingRequest interface.
 */
export function instanceOfTriggerVtmfFilingRequest(value: object): value is TriggerVtmfFilingRequest {
    return true;
}

export function TriggerVtmfFilingRequestFromJSON(json: any): TriggerVtmfFilingRequest {
    return TriggerVtmfFilingRequestFromJSONTyped(json, false);
}

export function TriggerVtmfFilingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerVtmfFilingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'idempotency_key': json['idempotency_key'] == null ? undefined : json['idempotency_key'],
    };
}

export function TriggerVtmfFilingRequestToJSON(json: any): TriggerVtmfFilingRequest {
    return TriggerVtmfFilingRequestToJSONTyped(json, false);
}

export function TriggerVtmfFilingRequestToJSONTyped(value?: TriggerVtmfFilingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idempotency_key': value['idempotency_key'],
    };
}
